import React from 'react';
import { Select } from '@material-ui/core';
import { getNowLuxonDateTime } from '../../../../../../utils/luxonUtil';

interface Props {
  value: luxon.DateTime,
  onChange: (e: React.ChangeEvent<{
    name?: string | undefined;
    value: unknown;
  }>) => void,
}

/** タクシー・ハイヤー予約画面の日付（年号部分）のセレクトボックスのコンポーネント。 */
export const SelectYear: React.FC<Props> = (props: Props) => {
  /** 現在日時。 */
  const now = getNowLuxonDateTime();
  /** 現在日時の年部分。 */
  const year = now.year;
  /** 現在日時の翌年。 */
  const nextYear = year + 1;
  /** 選択対象の年号（現在日時の年と翌年）の年号を格納した配列。 */
  const years = [
    year,
    nextYear,
  ];
  // 年始の場合には前の年も選べるようにする
  if(now.month === 0 && now.day < 4) {
    years.unshift(year - 1);
  }

  /** セレクトボックスの初期値。 */
  // 設定されている日時の年号。
  const defaultValue = props.value.year;

  return (
    <Select native value={defaultValue} onChange={props.onChange}>
      {
        years.map((y) => {
          return (<option value={y} key={`years_${y}`}>{y}</option>);
        })
      }
    </Select>
  );
}

export default SelectYear;
